import React from 'react';

import { ArticleMediaFrame, ArticleShell } from '../../articleStyles';
import { useHelpCenterLocale } from '../../localization';
import { HelpCenterContentDefinition } from '../../types';
import pdfUrl from './Agendamento de visita.pdf';
import * as s from './styles';
import translations from './translations';

export const VISIT_SCHEDULED_GUIDE_SLUG = 'visit-scheduled-guide';

const Content: React.FC<{ mode: 'page' | 'modal'; }> = ({ mode }) => {
  const t = useHelpCenterLocale(translations);

  return (
    <ArticleShell mode={mode}>
      <ArticleMediaFrame cleanMode>
        <s.PdfActions>
          <s.PdfActionLink href={pdfUrl} target="_blank" rel="noreferrer">
            {t.openPdfLabel}
          </s.PdfActionLink>
          <s.PdfActionLink href={pdfUrl} download>
            {t.downloadPdfLabel}
          </s.PdfActionLink>
        </s.PdfActions>

        <s.PdfViewport
          title={t.documentFrameTitle}
          src={pdfUrl}
          compact={mode === 'modal'}
          loading="lazy"
        />
      </ArticleMediaFrame>
    </ArticleShell>
  );
};

const visitScheduledGuide: HelpCenterContentDefinition = {
  id: 'visit-scheduled-guide',
  slug: VISIT_SCHEDULED_GUIDE_SLUG,
  meta: translations,
  keywords: {
    en: ['visit schedule', 'scheduled visits', 'pdf', 'guide', 'calendar'],
    pt: ['visitas agendadas', 'agendamento de visita', 'pdf', 'guia', 'calendario'],
  },
  order: 3,
  visibility: {
    type: 'permission',
    permission: 'visitSchedule-list',
  },
  allowedDisplayModes: ['page', 'modal'],
  Content,
};

export default visitScheduledGuide;
